import { ApiErrorData } from 'store/interfaces';

export default (error: unknown): error is ApiErrorData =>
  !!error &&
  typeof error === 'object' &&
  ('message' in error || 'description' in error);
